import { Reveal } from "../Reveal";
import { GoldButton } from "../GoldButton";
import { PLANS, SITE, waLink } from "../../config/site";

const PriceCard = ({ p }) => (
  <div className={`relative rounded-xl p-5 text-center border ${p.best ? "border-gold bg-paper shadow-[0_10px_30px_rgba(184,134,46,0.12)]" : "border-line bg-paper"}`}>
    {p.best && <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 rounded-full bg-gold px-3 py-0.5 font-body text-[10px] font-bold uppercase tracking-[0.14em] text-white">Melhor valor</span>}
    <p className="font-body text-xs uppercase tracking-[0.16em] text-slate/60">{p.label}</p>
    <p className="font-display text-gold text-3xl md:text-4xl tracking-tight mt-2">{p.price}<span className="font-body text-slate/50 text-sm tracking-normal">{p.per}</span></p>
  </div>
);

const Group = ({ g, delay }) => (
  <Reveal delay={delay}>
    <div className="rounded-2xl border border-line bg-sand p-7 md:p-9">
      <h3 className="font-display text-ink uppercase tracking-[0.1em] text-xl md:text-2xl">{g.title}</h3>
      <div className="flex flex-col gap-7 mt-7">
        {g.tiers.map((tier) => (
          <div key={tier.name}>
            <p className="font-body text-sm font-semibold text-slate/70 uppercase tracking-[0.14em] mb-3">{tier.name}</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {tier.plans.map((p) => <PriceCard key={p.label} p={p} />)}
            </div>
          </div>
        ))}
        {g.combo && (
          <div className="rounded-xl border-2 border-gold bg-paper p-6 flex flex-col md:flex-row md:items-center gap-4 justify-between">
            <div>
              <p className="font-display text-ink uppercase tracking-[0.1em] text-lg">{g.combo.title}</p>
              <p className="font-body text-slate/70 text-sm mt-1">{g.combo.note}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="font-body text-[11px] uppercase tracking-[0.16em] text-gold">{g.combo.label}</p>
              <p className="font-display text-gold text-4xl tracking-tight">{g.combo.price}<span className="font-body text-slate/50 text-sm">{g.combo.per}</span></p>
            </div>
          </div>
        )}
      </div>
      <div className="mt-8">
        <GoldButton href={waLink(g.waMsg)} target="_blank" rel="noopener noreferrer" className="w-full">{g.cta}</GoldButton>
      </div>
    </div>
  </Reveal>
);

export const Planos = () => {
  return (
    <section id="planos" data-testid="pricing-section" className="relative py-24 md:py-32 bg-paper">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-body text-xs tracking-[0.3em] uppercase text-gold">Planos</span>
          <h2 className="font-display text-ink uppercase tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5">Planos</h2>
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-6 mt-14 items-start">
          <Group g={PLANS.grupo1} delay={0} />
          <Group g={PLANS.grupo2} delay={0.08} />
        </div>
        <Reveal delay={0.1}>
          <div className="mt-12 rounded-2xl border border-line bg-sand px-6 py-6 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-2 text-center">
            <span className="font-body text-slate/80 text-sm"><span className="text-gold font-semibold">Kimono oficial Templo</span> para as primeiras {SITE.kimonoSpots} matrículas do plano anual</span>
            <span className="hidden sm:inline text-gold/40">·</span>
            <span className="font-body text-slate/80 text-sm">Início das aulas em {SITE.classesStart}</span>
            <span className="hidden sm:inline text-gold/40">·</span>
            <span className="font-body text-slate/80 text-sm">Savassi · Belo Horizonte</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
